import { render } from "./UserSelector.vue?vue&type=template&id=21e74ac6&scoped=true"
import script from "./UserSelector.vue?vue&type=script&lang=ts"
export * from "./UserSelector.vue?vue&type=script&lang=ts"

import "./UserSelector.vue?vue&type=style&index=0&id=21e74ac6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21e74ac6"

export default script